import { useState } from 'react';
import Input from '../ui/Input';
import Button from '../ui/Button';
import { useTuneStore } from '../../state/storeTunePrayer';
import { useConditional } from '../../state/storeConditional ';
import { useTimeTableMonth } from '../../state/storeTimeTable';

const TunePrayer = () => {
  const Imsak = useTuneStore((state) => state.Imsak);
  const Fajr = useTuneStore((state) => state.Fajr);
  const Sunrise = useTuneStore((state) => state.Sunrise);
  const Dhuhr = useTuneStore((state) => state.Dhuhr);
  const Asr = useTuneStore((state) => state.Asr);
  const Sunset = useTuneStore((state) => state.Sunset);
  const Maghrib = useTuneStore((state) => state.Maghrib);
  const Isha = useTuneStore((state) => state.Isha);
  const Midnight = useTuneStore((state) => state.Midnight);
  const TimeTableMonthFullYear = useTimeTableMonth((state) => state.TimeTableMonthFullYear);
  const { updateIsReadyToPost, isReadyGenerator } = useConditional();
  const [loading, setLoading] = useState(false);

  const handlerGenerate = () => {
    if (isReadyGenerator) {
      setLoading(true);
      // Simulating an async operation
      setTimeout(() => {
        updateIsReadyToPost(true);
        setLoading(false);
      }, 2000);
    }
  };

  const handlerDownloadCSV = () => {
    // first check if object and return! if not convert to object
    let timeTableMonth =
      typeof TimeTableMonthFullYear !== 'object' && TimeTableMonthFullYear !== undefined
        ? JSON.parse(TimeTableMonthFullYear)
        : TimeTableMonthFullYear;
    let timeTableColumnKey =
      `${Object.keys(timeTableMonth[0])
        .map((value) => `"${value}"`)
        .join(',')}` + '\r\n';

    let csvContent = timeTableMonth.reduce((timeTableValue: string, next: { [s: string]: unknown; } | ArrayLike<unknown>) => {
      timeTableValue +=
        `${Object.values(next)
          .map((value) => `"${value}"`)
          .join(',')}` + '\r\n';
      return timeTableValue;
    }, timeTableColumnKey);
    let element = document.createElement('a');
    element.href = 'data:text/csv;charset=utf-8,' + encodeURI(csvContent);
    element.target = '_blank';
    element.download = 'fiveprayer.csv';
    element.click();
  };

  return (
    <div className="">
      <h2 className="text-lg text-green-600 py-2">
        Tune Prayer (in minutes)
      </h2>
      <div className="grid gap-1  grid-cols-4 grid-rows-3 ">
        <Input value={Imsak} label="Imsak" />
        <Input value={Fajr} label="Fajr" />
        <Input value={Sunrise} label="Sunrise" />
        <Input value={Dhuhr} label="Dhuhr" />
        <Input value={Asr} label="Asr" />
        <Input value={Sunset} label="Sunset" />
        <Input value={Maghrib} label="Maghrib" />
        <Input value={Isha} label="Isha" />
        <Input value={Midnight} label="Midnight" />

        <Button
          onPress={handlerGenerate}
          classBtnWrapper="col-span-2 row-span-3"
          text={loading ? 'Loading...' : 'Generate Calendar'}
          label="Generate Time"
        />
        <Button onPress={handlerDownloadCSV} text="Download" label="File CSV" />
      </div>
    </div>
  );
};

export default TunePrayer;
